import { useEffect } from 'react'
import { useLocation } from 'react-router'
import Base from '../../pages/Base'
import AppLauncher from '../../components/AppLauncher'
import redirect from '../../utils/redirect'

const getLaunchUrl = (search) => {
  const params = new URLSearchParams(search)
  const redirectUrl = params.get('next')
  if (!redirectUrl) return ''
  params.delete('next')
  const query = params.toString()
  const sep = redirectUrl.includes('?') ? '&' : '?'
  return query ? redirectUrl + sep + query : redirectUrl
}

export const AppLauncherPage = (props) => {
  const {
    metadata: { client },
    brandingSettings,
    showGoogleFooterLink,
  } = props
  const { search } = useLocation()
  const launchUrl = getLaunchUrl(search)

  useEffect(() => {
    if (launchUrl) redirect(launchUrl)
  }, [launchUrl])

  return (
    <Base
      brandingSettings={brandingSettings}
      showGoogleFooterLink={showGoogleFooterLink}
      showReturnButton={false}
    >
      <AppLauncher name={client.name} launchUrl={launchUrl} />
    </Base>
  )
}

export default AppLauncherPage
